import {
  AccountHeader,
  Navigation,
  useFlags,
} from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { useIdForCurrentLocation } from "./hooks/useSelectedPath";
import { translatedSections } from "./Navigation.data";
import { NavigationProps } from "./Navigation.types";

import { AccountFlags } from "../../featureFlags";
import { useCurrentUser } from "../../hooks/currentUser";

const AccountNavigation = ({
  withinMenu,
  isOpen,
  onClose,
}: NavigationProps) => {
  const userInfo = useCurrentUser();
  const { t } = useTranslation();
  const selectedId = useIdForCurrentLocation();
  const excludedPaths = {} as Record<string, boolean>;
  const { tsFeAccountOrgSectionVisibility } = useFlags<AccountFlags>();

  if (!tsFeAccountOrgSectionVisibility) {
    excludedPaths["/organizations"] = true;
  }

  return (
    <Navigation
      withinMenu={withinMenu}
      isOpen={isOpen}
      testId="account-navigation"
      selectedId={selectedId}
      linkComponent={Link}
      onClose={onClose}
      sections={translatedSections(t, excludedPaths)}
      variant="light"
      renderHeader={({ isExpanded }) => (
        <AccountHeader user={userInfo.user} isExpanded={isExpanded} />
      )}
    />
  );
};

export default AccountNavigation;
